import axios from "axios";
import {env} from "../env";
import history from "../helper/history"

const setupAxios = () => {
    axios.defaults.baseURL = env.BASE_URL;
    axios.interceptors.request.use(
        (config) => {
            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            try {
                const status = error?.response?.status;
                if (status === 401) {
                    sessionStorage.clear();
                    window.location.reload();
                    history.replace('/');
                } else if (status === 404) {
                    history.replace('/');
                }
            } catch (e) {
                console.error(e);
            }
            return Promise.reject(error);
        }
    );
};

export {
    setupAxios
}